'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImageWithFocusPoint = require('./ImageWithFocusPoint');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ImageWithFocusPoint).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }